import React from 'react'
import { Text } from 'elements'
import CompanyInfoItems from './CompanyInfoItems'
import { useAuth } from 'hooks'

export default function BannerContent(props) {
  const auth = useAuth()

  return (
    <>
      <Text fontSize="xxxlarge" fontWeight="bold" color="background.0" mr="xxxlarge">
        {auth?.currentCompany?.name}
      </Text>

      <CompanyInfoItems items={props.items} />
    </>
  )
}
